<template>
    <div class="materials-list">
        <data-table
            :items="materials"
            :fields="fields"
            empty-text="There are no tips &amp; materials for this module section"
            :show-search-input="false"
            :show-items-per-page-select="true"
            :show-details-row="false"
        >
            <template #links="{ item }">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div class="material">
                            <div class="material-left">
                                <a 
                                    v-if="!isFavorite"
                                    class="btn btn-link icon-star" 
                                    :class="{favorite: isUserFavorite(item)}"
                                    @click="favoriteMaterial(item)"
                                ></a>
                                <div 
                                    v-else 
                                    class="module-icons mr-3 favorites" 
                                    :class="getModuleStyle(item)"
                                ></div>
                                <div class="material-info">
                                    <a v-if="item.is_video"
                                        :href="'#'+item.main_link.url" 
                                        @click.prevent="showVideo(item.main_link, item)"
                                    >
                                        {{item.name}}
                                    </a>
                                    <a v-else :href="$basePath+'/tips-and-materials/'+item.slug" target="material">{{item.name}}</a>
                                        <small v-if="item.secondary_link">
                                            (<a v-if="item.is_video"
                                                :href="'#'+item.secondary_link.url" 
                                                @click.prevent="showVideo(item.secondary_link)"
                                            >
                                                Spanish version
                                            </a>
                                            <a v-else :href="$basePath+'/tips-and-materials/'+item.slug+'?link=secondary'" target="material">Spanish version</a>)
                                        </small>
                                </div>
                                <div class="material-link">
                                    <a :href="item.source_url">{{item.source_name}}</a>
                                    <span v-if="item.source_location">, {{item.source_location}}</span>
                                </div> 
                            </div>
                            <div class="material-tags">
                                <small v-for="(tag, idx) in item.tags" :key="tag.id">
                                    <span v-if="idx > 0">,</span> 
                                    <a class="material-tag" :href="$basePath+'/tips-and-materials/search?search_term='+tag.name.en">{{ tag.name.en.toUpperCase() }}</a>
                                </small>
                            </div>
                        </div>
                    </li>
                </ul>
            </template>
        </data-table>
    </div>
</template>

<style lang="scss">
    @import "../../../sass/variables";
    @import "../../../sass/pages/tips_and_materials";

    .table td {
        padding: 0;
    }

    .table td .list-group {
        border: none;
    }

    .table td .list-group .list-group-item {
        border-radius: 0;
    }
</style>

<script>
    import Auth from '../../auth.js'
    import { mapWritableState } from 'pinia'
    import { useMaterialsStore } from './store.js';
    import DataTable from '../DataTable.vue';

    export default {
        props: {
            materials: {
                required: true,
                type: Array
            },
            isFavorite: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                userFavorites: [],
                fields: [
                    {
                        key: 'links',
                        sortable: false,
                    },
                ],
            }
        },
        components: { 
            DataTable 
        },
        computed: {
            ...mapWritableState(useMaterialsStore, {
                currentVideo: 'video'
            }),
        },
        methods: {
            showVideo(video, material) {
                if(typeof video ==="string") {
                    this.currentVideo = JSON.parse(video);
                }
                else{
                    this.currentVideo = video
                }

                $("#video-modal").modal('show')
            },
            getModuleStyle(material) {
                const icon = material.sections[0].module.icon
                const style = (this.isUserFavorite(material)) ? 'favorite' : '';
                return style + ' ' + icon;

            },
            favoriteMaterial(material) {
                if (this.userFavorites.indexOf(material.id) == -1) {
                    return window.axios.post('/api/users/'+Auth.user.id+'/materials', {material_id: material.id})
                        .then((response) => {
                            this.userFavorites.push(response.data.material_id)
                        })
                        .catch((error) => console.log('error'));
                }
                return window.axios.delete('/api/users/'+Auth.user.id+'/materials/'+material.id)
                    .then((response) => this.userFavorites.splice(this.userFavorites.indexOf(material.id), 1))
                    .catch((error) => console.error(error))
            },
            isUserFavorite(material) {
                return this.userFavorites.indexOf(material.id) > -1
            },
        },
        mounted() {
            this.userFavorites = Auth.user.favorite_materials.map((item) => item.id);
            useMaterialsStore()
        }
        //component definition
    }
</script>